function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverviewStory2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 553.7 399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "overview-story2-container",
    id: "Group_359",
    "data-name": "Group 359"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    x: 1,
    y: 1,
    width: 551.7,
    height: 397,
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    x: 1,
    y: 1,
    width: 551.7,
    height: 397,
    style: {
      fill: "none",
      stroke: "#221f20",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "overview-story2-topline",
    id: "Line_3",
    "data-name": "Line 3",
    x1: 1,
    y1: 109.1,
    x2: 552.7,
    y2: 109.1,
    style: {
      fill: "none",
      stroke: "#221f20",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "overview-story2-botline",
    id: "Line_4",
    "data-name": "Line 4",
    x1: 1,
    y1: 257.4,
    x2: 552.7,
    y2: 257.4,
    style: {
      fill: "none",
      stroke: "#221f20",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "overview-story2-topitems"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M99.2,71.5v7.8h-29.6c-1.3-2.9-4.7-4.2-7.7-2.9-2.9,1.3-4.2,4.7-2.9,7.7,1.3,2.9,4.7,4.2,7.7,2.9,1.3-.6,2.3-1.6,2.9-2.9h29.6v7.5H27.1v-7.5h15.5c.6,0,1.2-.2,1.7-.7l11.9-11.9h43.1Z",
    style: {
      fill: "#c1c1c1",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M99.2,42.9v23.8h-44.1c-.6,0-1.2.2-1.7.7l-11.9,11.9h-14.5v-8.7h3.8c1.3,2.9,4.7,4.2,7.7,2.9,2.9-1.3,4.2-4.7,2.9-7.7-1.3-2.9-4.7-4.2-7.7-2.9-1.3.6-2.3,1.6-2.9,2.9h-3.8v-8.7h17.6c1.3,2.9,4.7,4.2,7.7,2.9s4.2-4.7,2.9-7.7-4.7-4.2-7.7-2.9c-1.3.6-2.3,1.6-2.9,2.9h-17.6v-9.5h26.9l11.9,11.9c.4.5,1.1.7,1.7.7h15c.8,2.2,3,3.5,5.3,3.4,3.1-.2,5.6-2.7,5.8-5.8-.1-3.1-2.7-5.6-5.8-5.8-2.3-.1-4.4,1.2-5.3,3.4h-14.1l-11.9-11.9c-.4-.5-1-.7-1.7-.7h-21.6l6.3-4.8h24.9c.8,2.2,3,3.5,5.3,3.4,3.1-.2,5.6-2.7,5.8-5.8-.2-3.1-2.7-5.6-5.8-5.8-2.3-.1-4.4,1.2-5.3,3.4h-18.6l17.3-13.1,36.1,27.4Z",
    style: {
      fill: "#c1c1c1",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x1: 518.6,
    y1: 38,
    x2: 404.6,
    y2: 38,
    style: {
      fill: "none",
      stroke: "#6d6d6d",
      strokeLinecap: "round",
      strokeWidth: 16
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x1: 518.6,
    y1: 72,
    x2: 383.5,
    y2: 72,
    style: {
      fill: "none",
      stroke: "#6d6d6d",
      strokeLinecap: "round",
      strokeWidth: 16
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "overview-story2-bottomitems"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3,138.5h6.1l4.6,22.4,4.8-22.4h6l.6,32.4h-4.4l-.5-22.5-4.6,22.5h-3.6l-4.7-22.6-.4,22.6h-4.4l.6-32.4Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6,160.8v-12.2c0-6.6,2.4-10.4,9.4-10.4s9.3,3.9,9.3,10.4v12.2c0,6.5-2.4,10.6-9.3,10.6s-9.4-4-9.4-10.6ZM61.3,162.2v-14.9c0-2.7-.4-4.8-3.3-4.8s-3.4,2-3.4,4.8v14.9c0,2.7.4,4.8,3.4,4.8s3.3-2.2,3.3-4.8Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7,138.5h7.6c7.9,0,10.3,3.2,10.3,10.1v11.8c0,7.1-2.4,10.5-10,10.5h-7.9v-32.4ZM79.4,166.8c4,0,4.2-2.2,4.2-6.2v-12.4c0-3.9-.4-5.5-4.3-5.5h-1.8v24.1h1.8Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,138.5h13.6v4.2h-7.7v9.3h6.1v4.1h-6.1v10.8h7.8v4h-13.7v-32.4Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.1,138.5h5.9v28.4h7.9v4h-13.8v-32.4Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.8,159.8h-2v-3.6h2.5l.6-4.3h-2.9v-3.7h3.5l1.2-9.6h4.2l-1.2,9.6h3.3l1.3-9.6h4.2l-1.3,9.6h1.9v3.7h-2.4l-.6,4.3h2.9v3.6h-3.4l-1.5,11.2h-4.2l1.5-11.2h-3.3l-1.4,11.2h-4.2l1.4-11.2ZM146.8,156.1l.6-4.3h-3.3l-.6,4.3h3.4Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_408-2",
    "data-name": "Group 408-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    x: 53.9,
    y: 290.8,
    width: 446,
    height: 87.3,
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_209",
    "data-name": "Rectangle 209",
    x: 66.9,
    y: 297.8,
    width: 2.3,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_210",
    "data-name": "Rectangle 210",
    x: 74.8,
    y: 297.8,
    width: 1.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    x: 78.4,
    y: 297.8,
    width: 1.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_212",
    "data-name": "Rectangle 212",
    x: 63.8,
    y: 297.8,
    width: 0.9,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    "data-name": "Rectangle 213",
    x: 60.3,
    y: 297.8,
    width: 0.9,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    x: 84.2,
    y: 297.8,
    width: 1.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215",
    "data-name": "Rectangle 215",
    x: 313.8,
    y: 297.8,
    width: 1.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    x: 405.4,
    y: 297.8,
    width: 1.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    x: 287.8,
    y: 297.8,
    width: 1.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    "data-name": "Rectangle 218",
    x: 293.5,
    y: 297.8,
    width: 1.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    x: 298.6,
    y: 297.8,
    width: 0.5,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_220",
    "data-name": "Rectangle 220",
    x: 262.2,
    y: 297.8,
    width: 1.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    x: 267.8,
    y: 297.8,
    width: 1.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_222",
    "data-name": "Rectangle 222",
    x: 274.3,
    y: 297.8,
    width: 0.5,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_223",
    "data-name": "Rectangle 223",
    x: 101.2,
    y: 297.8,
    width: 2.3,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_224",
    "data-name": "Rectangle 224",
    x: 92,
    y: 297.8,
    width: 4.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_225",
    "data-name": "Rectangle 225",
    x: 138.1,
    y: 297.8,
    width: 2.3,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_226",
    "data-name": "Rectangle 226",
    x: 164.4,
    y: 297.8,
    width: 4.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_227",
    "data-name": "Rectangle 227",
    x: 229,
    y: 297.8,
    width: 4.6,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_228",
    "data-name": "Rectangle 228",
    x: 254.1,
    y: 297.8,
    width: 2.3,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_229",
    "data-name": "Rectangle 229",
    x: 246.6,
    y: 297.8,
    width: 0.7,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_230",
    "data-name": "Rectangle 230",
    x: 238.8,
    y: 297.8,
    width: 0.7,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_231",
    "data-name": "Rectangle 231",
    x: 118.4,
    y: 297.8,
    width: 1.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_232",
    "data-name": "Rectangle 232",
    x: 129.6,
    y: 297.8,
    width: 0.7,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_233",
    "data-name": "Rectangle 233",
    x: 124.1,
    y: 297.8,
    width: 0.7,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_234",
    "data-name": "Rectangle 234",
    x: 150.9,
    y: 297.8,
    width: 0.7,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_235",
    "data-name": "Rectangle 235",
    x: 156.9,
    y: 297.8,
    width: 1.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_236",
    "data-name": "Rectangle 236",
    x: 170.5,
    y: 297.8,
    width: 0.7,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_237",
    "data-name": "Rectangle 237",
    x: 173.4,
    y: 297.8,
    width: 1.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238",
    "data-name": "Rectangle 238",
    x: 145.4,
    y: 297.8,
    width: 0.7,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    x: 132.5,
    y: 297.8,
    width: 2.3,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_240",
    "data-name": "Rectangle 240",
    x: 112.6,
    y: 297.8,
    width: 1.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_241",
    "data-name": "Rectangle 241",
    x: 107.5,
    y: 297.8,
    width: 1.6,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_242",
    "data-name": "Rectangle 242",
    x: 280.3,
    y: 297.8,
    width: 2.3,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_243",
    "data-name": "Rectangle 243",
    x: 184.3,
    y: 297.8,
    width: 1.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_244",
    "data-name": "Rectangle 244",
    x: 189.9,
    y: 297.8,
    width: 1.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_245",
    "data-name": "Rectangle 245",
    x: 203.5,
    y: 297.8,
    width: 2.1,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_246",
    "data-name": "Rectangle 246",
    x: 211.4,
    y: 297.8,
    width: 2.1,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    x: 207.9,
    y: 297.8,
    width: 1.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_248",
    "data-name": "Rectangle 248",
    x: 195,
    y: 297.8,
    width: 0.5,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_249",
    "data-name": "Rectangle 249",
    x: 217.7,
    y: 297.8,
    width: 0.5,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_250",
    "data-name": "Rectangle 250",
    x: 221.6,
    y: 297.8,
    width: 0.5,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    x: 241.5,
    y: 297.8,
    width: 0.5,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_252",
    "data-name": "Rectangle 252",
    x: 249.9,
    y: 297.8,
    width: 1.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    x: 176.7,
    y: 297.8,
    width: 2.3,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    x: 304.1,
    y: 297.8,
    width: 2.3,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    x: 322.5,
    y: 297.8,
    width: 2.3,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_256",
    "data-name": "Rectangle 256",
    x: 317.1,
    y: 297.8,
    width: 2.3,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_257",
    "data-name": "Rectangle 257",
    x: 330.9,
    y: 297.8,
    width: 0.7,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_258",
    "data-name": "Rectangle 258",
    x: 334.6,
    y: 297.8,
    width: 0.7,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_259",
    "data-name": "Rectangle 259",
    x: 338.3,
    y: 297.8,
    width: 2.3,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_260",
    "data-name": "Rectangle 260",
    x: 346.2,
    y: 297.8,
    width: 1.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_261",
    "data-name": "Rectangle 261",
    x: 355.6,
    y: 297.8,
    width: 1.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    x: 372.6,
    y: 297.8,
    width: 2.3,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_263",
    "data-name": "Rectangle 263",
    x: 363.4,
    y: 297.8,
    width: 4.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_264",
    "data-name": "Rectangle 264",
    x: 409.5,
    y: 297.8,
    width: 2.3,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_265",
    "data-name": "Rectangle 265",
    x: 435.7,
    y: 297.8,
    width: 4.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    x: 389.7,
    y: 297.8,
    width: 1.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_267",
    "data-name": "Rectangle 267",
    x: 400.9,
    y: 297.8,
    width: 0.7,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_268",
    "data-name": "Rectangle 268",
    x: 395.5,
    y: 297.8,
    width: 0.7,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_269",
    "data-name": "Rectangle 269",
    x: 422.3,
    y: 297.8,
    width: 0.7,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_270",
    "data-name": "Rectangle 270",
    x: 433,
    y: 297.8,
    width: 0.7,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_271",
    "data-name": "Rectangle 271",
    x: 442.2,
    y: 297.8,
    width: 0.7,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_272",
    "data-name": "Rectangle 272",
    x: 428.2,
    y: 297.8,
    width: 1.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_273",
    "data-name": "Rectangle 273",
    x: 416.8,
    y: 297.8,
    width: 0.7,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_274",
    "data-name": "Rectangle 274",
    x: 384,
    y: 297.8,
    width: 1.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_275",
    "data-name": "Rectangle 275",
    x: 378.9,
    y: 297.8,
    width: 1.6,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_276",
    "data-name": "Rectangle 276",
    x: 455.7,
    y: 297.8,
    width: 1.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    x: 461.3,
    y: 297.8,
    width: 1.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    x: 474.9,
    y: 297.8,
    width: 2.1,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_279",
    "data-name": "Rectangle 279",
    x: 481.7,
    y: 297.8,
    width: 4.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_280",
    "data-name": "Rectangle 280",
    x: 470.7,
    y: 297.8,
    width: 1.2,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_281",
    "data-name": "Rectangle 281",
    x: 466.4,
    y: 297.8,
    width: 0.5,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    x: 445.7,
    y: 297.8,
    width: 0.5,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_283",
    "data-name": "Rectangle 283",
    x: 489.1,
    y: 297.8,
    width: 0.5,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_284",
    "data-name": "Rectangle 284",
    x: 493,
    y: 297.8,
    width: 0.5,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_285",
    "data-name": "Rectangle 285",
    x: 448.1,
    y: 297.8,
    width: 2.3,
    height: 63.1,
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4,216.9l2.6-.7c.2,2.3.7,4.5,3,4.5s2.3-.9,2.3-2.5-1-2.9-2.3-4.1l-3.5-3.1c-1.4-1.2-2-2.5-2-4.7,0-3.1,1.9-4.9,4.9-4.9s5,1.7,5.3,5.4l-2.5.7c-.2-2.1-.6-3.8-2.8-3.8s-2.3.8-2.3,2.3.4,2,1.4,2.9l3.6,3.1c1.6,1.4,3,3.3,3,5.9s-2.1,5-5,5-5.4-2.5-5.6-6.1Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3,201.8h8.2v2.2h-5.2v7h4.2v2.1h-4.2v7.7h5.3v2.1h-8.2v-21.1Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9,201.8h4.2c4.2,0,6.2,1.6,6.2,5.6s-.7,4.3-2.6,4.9l3,10.6h-2.8l-2.8-9.9h-2.3v9.9h-2.9v-21.1ZM48,210.9c2.5,0,3.5-.8,3.5-3.5s-.7-3.5-3.4-3.5h-1.3v7h1.1Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6,201.8h2.9v21.1h-2.9v-21.1Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2,201.8h2.8l4.5,21.1h-2.8l-1-5.3h-4.3l-1,5.3h-2.8l4.5-21.1ZM70.4,215.4l-1.8-9.5-1.7,9.5h3.5Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6,201.8h2.9v19h5.4v2.1h-8.3v-21.1Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2,215.3h-1.1v-2.1h1.4l.4-2.5h-1.7v-2.1h2l1-6.8h2.8l-1,6.8h2.3l1-6.8h2.8l-1,6.8h1.1v2.1h-1.4l-.4,2.5h1.7v2.1h-1.9l-1.1,7.5h-2.8l1.1-7.5h-2.3l-1.1,7.5h-2.8l1.1-7.5ZM98.6,213.2l.4-2.5h-2.3l-.4,2.5h2.3Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x1: 518.6,
    y1: 156.5,
    x2: 296.5,
    y2: 156.5,
    style: {
      fill: "none",
      stroke: "#e4a05d",
      strokeLinecap: "round",
      strokeWidth: 16
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x1: 383.5,
    y1: 211.3,
    x2: 327.5,
    y2: 211.3,
    style: {
      fill: "none",
      stroke: "#6d6d6d",
      strokeLinecap: "round",
      strokeWidth: 16
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x1: 493.5,
    y1: 211.3,
    x2: 437.5,
    y2: 211.3,
    style: {
      fill: "none",
      stroke: "#6d6d6d",
      strokeLinecap: "round",
      strokeWidth: 16
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x1: 410.5,
    y1: 211.3,
    x2: 407.6,
    y2: 211.3,
    style: {
      fill: "none",
      stroke: "#6d6d6d",
      strokeLinecap: "round",
      strokeWidth: 16
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-2",
    "data-name": "Line 9",
    x1: 275.4,
    y1: 211.3,
    x2: 219.4,
    y2: 211.3,
    style: {
      fill: "none",
      stroke: "#6d6d6d",
      strokeLinecap: "round",
      strokeWidth: 16
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11-2",
    "data-name": "Line 11",
    x1: 302.4,
    y1: 211.3,
    x2: 299.4,
    y2: 211.3,
    style: {
      fill: "none",
      stroke: "#6d6d6d",
      strokeLinecap: "round",
      strokeWidth: 16
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x1: 520.5,
    y1: 211.3,
    x2: 517.6,
    y2: 211.3,
    style: {
      fill: "none",
      stroke: "#6d6d6d",
      strokeLinecap: "round",
      strokeWidth: 16
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewStory2);
export default __webpack_public_path__ + "static/media/overview-story2.9e509cb0.svg";
export { ForwardRef as ReactComponent };